<template>
  <div class="webview">
    <!-- <iframe :src="imgUrl" width="100%" height="100%" frameborder="0" scrolling="auto" ></iframe> -->
  </div>
</template>

<script>
export default {
  name: 'vrview',
  data(){
    return{
      // url:'https://720yun.com/t/1ebj50hukv0?scene_id=11207386',
      imgUrl:''
    }
  },
  created(){
    console.log(this.$route.query)
    if(this.$route.query.type === "1"){
      this.imgUrl=this.$Api.ServerApi+'/vr/show?url='+this.$route.query.url
      console.log(this.imgUrl)
      window.open(this.imgUrl)
    }else{
      this.imgUrl=this.$route.query.url
      window.open(this.imgUrl)
    }
    this.$router.back()
  },
  // mounted(){
  // }
}
</script>

<style scoped>
  .webview{
    height: 100vh;
    width: 100%;
    background-color: #fff5ff;
  }
  .webview > iframe{
    height: inherit;
  }
</style>
